import { useCallback, useState } from "react";
import {
  createWebSubscriptionPortalSession,
  StripePortalFlow,
} from "../api/paymentApi";
import { useHostedStripeRedirectWaitingReset } from "./useHostedStripeRedirectWaitingReset";

export function useStripeCustomerPortal() {
  const [waiting, setWaiting] = useState(false);
  const [error, setError] = useState<string>();
  useHostedStripeRedirectWaitingReset(waiting, setWaiting);

  const openPortal = useCallback(async (flow: StripePortalFlow = "manage") => {
    setError(undefined);
    setWaiting(true);

    try {
      const response = await createWebSubscriptionPortalSession(flow);
      // Portal sessions always continue in Stripe-hosted UI; local success handling happens on return.
      window.location.assign(response.data.payload.results.portal_url);
    } catch (portalError) {
      setWaiting(false);
      // Callers decide whether to show inline errors or swallow portal failures for their UX.
      throw portalError;
    }
  }, []);

  return { openPortal, waiting, error, setError };
}
